import React, { useState, useEffect } from 'react';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';
import { Link, Route, useHistory } from 'react-router-dom';

import ChoixEcole from './souscomposants/ChoixEcole';
import Statns4 from './souscomposants/Statns4';
import SaisieNotes from './souscomposants/SaisieNotes';
import Bunexe_service from '../../Bunexe_service';
import { FaChartBar, FaPlusSquare, FaSchool } from 'react-icons/fa';
import StatsMat_anticipees from './souscomposants/StatsMat_anticipees';
// const [titre_, setTitre_] = useState('');

const Mat_anticipees = ({ match, code_dept, info, mon_ecole }) => {
  // const l = useLocation();
  // const n = l.pathname;
  const [ecole_selection, setEcole_selection] = useState(mon_ecole);
  const [titre_, setTitre_] = useState('');
  const histo = useHistory();
  const cheminpush = '/mat_anticipees/ns3';

  const getTitre = () => {
    let T = Bunexe_service.depts.filter((d) => d.code == code_dept)[0].titre;
    setTitre_(T);
  };

  useEffect(() => {
    getTitre();
  }, []);
  useEffect(() => {
    histo.push('/mat_anticipees/stat');
  }, [histo]);

  return (
    <div>
      {Bunexe_service.depts
        .filter((d) => d.code == code_dept)
        .map((dd) => (
          <h1 key={dd.code} className='text-center '>
            {dd.titre}
          </h1>
        ))}
      <h3 className='text-center'>Matières Anticipées - Sec-III </h3>
      {
        <>
          <div className='d-flex justify-content-center'>
            <Button
              className='bg-info mr-1'
              as={Link}
              to='/mat_anticipees/stat'
            >
              <FaChartBar size={20} />
            </Button>
            <Button className='bg-info mr-1' as={Link} to='/mat_anticipees/ns3'>
              <FaPlusSquare size={20} />
            </Button>
            {info.role_id != 'DI' && (
              <Button
                className='bg-info mr-1'
                as={Link}
                to='/mat_anticipees/choix'
              >
                <FaSchool size={20} />
              </Button>
            )}
          </div>
        </>
      }

      {/* ================      */}
      {/* {
        <ButtonToolbar
          className='justify-content-center'
          aria-label='Toolbar with Button groups'
        >
          <ButtonGroup aria-label='First group'>
            <Button as={Link} to='/sec4/stat' variant='secondary'>
              Statistiques
            </Button>{' '}
            <Button as={Link} to='/sec4/ns4' variant='secondary'>
              Nouveau
            </Button>{' '}
            <Button as={Link} to='/sec4/choix' variant='secondary'>
              Choix Ecole
            </Button>{' '}
          </ButtonGroup>
        </ButtonToolbar>
      } */}

      {/* <p className='mx-auto justify-content-center'>
        <Link to='/Mat_anticipees/ns4' style={{ marginRight: '10px' }}>
          Nouveau
        </Link>
        <Link to='/Mat_anticipees/choix'>Choix Ecole</Link>
      </p> */}
      {/* <h2>{`${match.url}/ns4`}</h2>
      <h4>{n}</h4> */}

      <Route
        exact
        path='/mat_anticipees/ns3'
        render={(props) =>
          !ecole_selection ? (
            <ChoixEcole
              {...props}
              setEcole_selection={setEcole_selection}
              code_dept={code_dept}
              cheminpush={cheminpush}
            />
          ) : (
            <SaisieNotes
              {...props}
              ecole_selection={ecole_selection}
              titre_={titre_}
            />
          )
        }
      />
      <Route
        exact
        path='/mat_anticipees/choix'
        render={(props) => (
          <ChoixEcole
            setEcole_selection={setEcole_selection}
            code_dept={code_dept}
            cheminpush={cheminpush}
          />
        )}
      />

      <Route
        exact
        path='/mat_anticipees/stat'
        render={(props) => (
          <StatsMat_anticipees code_dept={code_dept} titre_={titre_} />
        )}
      />

      {/* <Route path='/choix' component={ChoixEcole} /> */}
    </div>
  );
};

export default Mat_anticipees;
